import { apiInstances } from '../../../../libs';

const { post } = apiInstances.orderInstance;

export default async function confirmPickedUpAndDelivered(payload) {
  return await post(`/clouders/orders/pickupAndDeliverConsumer`, payload);
}
